module.exports = __webpack_public_path__ + "static/media/anim_404.c9aaa271.gif";